import Styles from './MetricContainer.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { InformationCircleContained } from 'blaze-ui/icons'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { ReactNode } from 'react'

interface MetricContainerProps {
  name: string
  tooltip: string
  headerContent?: ReactNode
  children: ReactNode
}

export const MetricContainer = ({ name, tooltip, headerContent, children }: MetricContainerProps) => {
  return (
    <div className={Styles.metric}>
      <div className={Styles.header}>
        <div className={Styles.name}>
          <Heading level={4}>{name}</Heading>
          <Tooltip label={tooltip}>
            <div className={Styles.icon}>
              <InformationCircleContained size={20} color="var(--dark-40)" />
            </div>
          </Tooltip>
        </div>
        {headerContent && <div className={Styles.metricValues}>{headerContent}</div>}
      </div>
      <div className={Styles.content}>{children}</div>
    </div>
  )
}
